export default function TableLoading({ size = 24, className = "text-[#808080]" }) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" className={className} fill="none">
      <circle className="zi-loading-dot" cx="4" cy="12" r="2" fill="currentColor" />
      <circle className="zi-loading-dot" cx="12" cy="12" r="2" fill="currentColor" />
      <circle className="zi-loading-dot" cx="20" cy="12" r="2" fill="currentColor" />
    </svg>
  );
}
